import { Autocomplete, Backdrop, Box, Button, CircularProgress, Grid, Paper, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import DetailsModal from "./bycustomer";
const ReferrerReport = () => {
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [customerdata] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [salesLines] = useState([])
  const [open] = useState(false)
  const [totalAmount] = useState(0)
  const [totalFlag] = useState(false)
  const outletId = localStorage.getItem('outlet_id')
  const roleId = localStorage.getItem("role_id")
  const [loading, setLoading] = useState(false);
  const [customerType, setCustomerType] = useState(null);
  const [rowToDelete] = useState(null);
  const [deleteIndex] = useState(null);
  const [dateLimit, setDateLimit] = useState({
    fromDate: moment().format(),
    toDate: moment().format()
  })
  const [cust, setCust] = useState(null)
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [, setSelectedRowData] = useState(null);
  const [search, setSearch] = useState('')

  console.log(pageCount, "pageCount");
  console.log(data, "datttttttt");

  const columns = [
    {
      field: 'sno',
      headerName: 'S.no',
      minWidth: 70,
      headerAlign: 'center',
      align: 'center',
      sortable: false
    },
    {
      field: "docdate",
      headerName: "Doc Date",
      minWidth: 130,
      headerAlign: "center",
      flex: 1,
      align: "center",
      sortable: false,
    },
    {
      field: "doc_no",
      headerName: "Doc No",
      minWidth: 130,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "bill_amount",
      headerName: "Bill Amount",
      minWidth: 130,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "is_rewarded",
      headerName: "Referee Status",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <span
          style={{
            color: params.value === "Purchased" ? "green" : "red",
            fontWeight: 600,
          }}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: "referrer_mobile",
      headerName: "Referrer Mobile No ",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "referrer_name",
      headerName: "Referrer Name",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "referee_mobile",
      headerName: "Referee Mobile No",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "referee_name",
      headerName: "Referee Name",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "referrer_points",
      headerName: "Referrer Points",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "referee_points",
      headerName: "Referee Points",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "referee_total_sales",
      headerName: "Referee Total Sales",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "referrer_total_sales",
      headerName: "Referrer Total Sales",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "customer_type",
      headerName: "Referee Customer Type",
      minWidth: 190,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <span
          style={{
            // color: params.value === "old" ? "blue" : "purple",
            color:
              params.value === "new" ? "green" :
                params.value === "old" ? "blue" :
                  "red",
            fontWeight: 600,
          }}
        >
          {params.value}
        </span>
      ),
    },
  ]

  console.log(data, "checkkk")
  const rows = _.map(data, (val, idx) => ({
    id: idx + 1,
    sno: idx + 1,
    docdate: val.docdate || "-",
    doc_no: val.doc_no || "-",
    bill_amount: val.bill_amount || "-",
    is_rewarded: val.is_rewarded ? "Purchased" : "Not Yet Purchased",
    referrer_mobile: val.referrer_mobile || "-",
    referrer_name: val.referrer_name || "-",
    referee_mobile: val.referee_mobile || "-",
    referee_name: val.referee_name || "-",
    referrer_points: val.referrer_points || 0,
    referee_points: val.referee_points || 0,
    referee_total_sales: val.referee_total_sales || 0,
    referrer_total_sales: val.referrer_total_sales || 0,
    customer_type: val.customer_type || "-",
  }));

  const props = {
    columns: columns,
    rows: rows,
    page: page,
    setPage: setPage,
    search: search,
    setSearch: setSearch,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
    totalAmount: totalAmount,
    totalFlag: totalFlag
  }
  console.log(props, "propsprops");

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRowData(null);
  };

  const handleConfirmDelete = () => {
    const deleteData = {
      outlet_sales_id: rowToDelete.id,
      outlet_id: cust !== null ? cust.id : outletId,
      docno: rowToDelete.billNo,
    };

    axios
      .post(`/v1/outlet_sales_master/delete`, deleteData)
      .then(() => {
        const updatedData = [...data];
        updatedData.splice(deleteIndex, 1);
        setData(updatedData);
        setOpenDeleteModal(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  function handleChange(e, name) {
    setDateLimit(prev => ({ ...prev, [name]: dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        _.filter(res.data, val => Number(val.id) === Number(outletId)).map(val => setCust(val))
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }

  function handleOutletSalesReport() {
    setLoading(true);
    const fromDate = moment(dateLimit.fromDate).format('YYYY-MM-DD');
    const toDate = moment(dateLimit.toDate).format('YYYY-MM-DD');
    const postData = {
      from_date: fromDate,
      to_date: toDate,
      // outlet_id: cust?.id || outletId || 1,
      outlet_id:
    cust?.id !== undefined && cust?.id !== null
      ? cust.id
      : outletId || 1,
      customer_type: customerType?.id || "all",
      page_size: rowsPerPage,
      current_page: page + 1
    };

    axios.post(`/v1/reports/referral/customersales`, postData)
      .then(res => {
        const responseData = res.data.data || [];
        setData(responseData);
        setPageCount(res.data.meta?.pagination?.total || res.data.total || 0);
        console.log(res.data, "API Response");
      })
      .catch(err => {
        console.error(err);
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleDownloadCSV = async () => {
    try {
      setLoading(true);

      const fromDate = moment(dateLimit.fromDate).format("YYYY-MM-DD");
      const toDate = moment(dateLimit.toDate).format("YYYY-MM-DD");
      const postData = {
        from_date: fromDate,
        to_date: toDate,
        // outlet_id: cust?.id || outletId || 1,
        outlet_id:
    cust?.id !== undefined && cust?.id !== null
      ? cust.id
      : outletId || 1,
        page_size: 10000,
        current_page: 1
      };

      const response = await axios.post(`/v1/reports/referral/customersales`, postData);
      const responseData = response.data.data || [];

      if (!responseData || responseData.length === 0) {
        alert("No data available for download.");
        return;
      }
      const headers = [
        "DocDate",
        "Doc No",
        "Bill Amount",
        "Referee Status",
        "Referrer Mobile",
        "Referrer Name",
        "Referee Mobile",
        "Referee Name",
        "Referrer Points",
        "Referee Points",
        "Referee Total Sales",
        "Referrer Total Sales",
        "Referee Customer Type",
      ];
      const csvRows = responseData.map((row) => [
        row.docdate,
        row.doc_no,
        row.bill_amount,
        row.is_rewarded ? "Purchased" : "Not Yet Purchased",
        row.referrer_mobile,
        row.referrer_name,
        row.referee_mobile,
        row.referee_name,
        row.referrer_points,
        row.referee_points,
        row.referee_total_sales,
        row.referrer_total_sales,
        row.customer_type,
      ]);

      // Convert data to CSV string
      const csvContent = [
        headers.join(","),
        ...csvRows.map((row) => row.join(",")),
      ].join("\n");

      // Convert CSV string to Blob
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

      // Create a download link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `referrer_sales_report_${moment().format("YYYY-MM-DD")}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file:", error);
      alert("Failed to download the CSV file. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  console.log(totalAmount, "totalAmount")

  useEffect(() => {
    getSupplierData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (dateLimit.fromDate !== null && dateLimit.toDate !== null) {
      handleOutletSalesReport()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage, page, dateLimit, cust, search, customerType])
  return (
    <Fragment>
      <Helmet><title>Outlet Referrer Reports</title></Helmet>
      <Typography variant="h6">Outlet Referrer Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete
            size="small"
            value={cust}
            // options={supplier}
            options={[{ id: 0, fullname: "All" }, ...supplier]}

            onChange={(e, value) => setCust(value)}
            getOptionLabel={option => option.fullname}
            disabled={Number(roleId) !== 1 && Number(roleId) !== 2}
            renderInput={(params) => <TextField {...params} label="Select Outlet"
              InputProps={{
                ...params.InputProps,
                readOnly: true,
              }}
            />}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              disabled={Number(roleId) !== 1 && Number(roleId) !== 2}
              slotProps={{
                textField: {
                  size: "small",
                  label: 'From',
                  style: { width: '100%' },
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              disabled={Number(roleId) !== 1 && Number(roleId) !== 2}
              slotProps={{
                textField: {
                  size: "small",
                  label: 'To',
                  style: { width: '100%' }
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <Autocomplete
            size="small"
            value={customerType || null}
            options={[
              { id: "all", fullname: "All" },
              { id: "new", fullname: "New" },
              { id: "old", fullname: "Old" },
              { id: "not purchased", fullname: "Not Purchased" }
              // {id: "old", fullname: "Old"}
            ]}
            onChange={(e, value) => setCustomerType(value)}
            getOptionLabel={(option) => option.fullname}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Referee Customer Type"
                InputProps={{
                  ...params.InputProps,
                  readOnly: true,
                }}
              />
            )}
          />
        </Grid>

        <Grid item md={3} style={{ display: 'flex', alignItems: 'center' }}>
          {/* <CSVLink */}


          <Button variant="contained" onClick={handleDownloadCSV}>Download CSV</Button>
          {/* </CSVLink> */}
        </Grid>
      </Grid>
      <Box position="relative" width="100%">
        {/* Table Container */}
        <Paper elevation={2}>
          <CustomTable props={props} />
        </Paper>

        {/* Loader Overlay */}
        {loading && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bgcolor="rgba(255, 255, 255, 0.7)" // Optional: background color for the overlay
            zIndex={1}
          >
            <CircularProgress size={50} /> {/* Material UI spinner */}
          </Box>
        )}
      </Box>
      <Backdrop open={open} sx={{ zIndex: 1450 }}>
        <DetailsModal
          open={isModalOpen}
          onClose={handleCloseModal}
          data={customerdata}
          salesLines={salesLines}

        />
      </Backdrop>
      {/* <Backdrop open={open} sx={{zIndex:1450}}>
        <ModalTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
      </Backdrop> */}
      <Backdrop open={openDeleteModal} sx={{ zIndex: 1350 }} onClose={() => setOpenDeleteModal(false)}>
        <DeletePage onCancel={setOpenDeleteModal} onSubmit={handleConfirmDelete} />
      </Backdrop>
    </Fragment>
  );
};

export default ReferrerReport;